import React from "react";
import PropTypes from "prop-types";
import style from "./style.module.css";

const RadioboxRounded = ({
  className,
  radioboxClassName,
  label = "",
  value,
  checked,
  ...props
}) => {
  return (
    <label
      className={`${style.radioboxRoundedLabel} ${className}`}
      data-checked={checked}
    >
      <input
        {...props}
        value={value || label}
        type="radio"
        className={`${style.radioboxRoundedInput} ${className}`}
        checked={checked}
      />
      {label}
    </label>
  );
};
RadioboxRounded.propTypes = {
  className: PropTypes.string,
  radioboxClassName: PropTypes.string
};

export default RadioboxRounded;
